module.exports = __webpack_public_path__ + "static/docs/TW_Umgebungsplan_050220_final.aa71f746.pdf";